"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRouterDom = require("react-router-dom");

var _List = _interopRequireDefault(require("../List"));

var _Button = _interopRequireDefault(require("../Button"));

var _context = _interopRequireDefault(require("./context"));

require("./styles.css");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj["default"] = obj;
    return newObj;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var BreadcrumbContent =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(BreadcrumbContent, _PureComponent);

  function BreadcrumbContent() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, BreadcrumbContent);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(BreadcrumbContent)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "renderBreadcrumbs", function (item, idx, arr) {
      var _this$context = _this.context,
          onRouteChange = _this$context.onRouteChange,
          separator = _this$context.separator;
      var loaderNode = _this.props.loaderNode;
      var title = item.title,
          value = item.value,
          loading = item.loading;
      var isLast = idx === arr.length - 1;
      return _react["default"].createElement(_react.Fragment, {
        key: "".concat(title, "_").concat(value)
      }, _react["default"].createElement(_List["default"].Item, {
        className: "crumbs"
      }, loading ? item.loaderNode || loaderNode : _react["default"].createElement(_Button["default"], {
        as: value ? _reactRouterDom.Link : null,
        basic: true,
        upperCase: true,
        to: value,
        href: value,
        onClick: !isLast ? function (e) {
          return onRouteChange(e, item);
        } : null,
        color: "blue"
      }, title)), !isLast ? _react["default"].createElement(_List["default"].Item, null, separator) : null);
    });

    return _this;
  }

  _createClass(BreadcrumbContent, [{
    key: "render",
    value: function render() {
      var data = this.context.data;
      var _this$props = this.props,
          loading = _this$props.loading,
          loaderNode = _this$props.loaderNode;

      if (loading && loaderNode) {
        return loaderNode;
      }

      if (data) {
        var filteredData = data.filter(function (d) {
          return d.visible;
        });
        return _react["default"].createElement(_List["default"], {
          className: BreadcrumbContent.className,
          horizontal: true,
          data: filteredData,
          itemNode: this.renderBreadcrumbs
        });
      }

      return null;
    }
  }]);

  return BreadcrumbContent;
}(_react.PureComponent);

exports["default"] = BreadcrumbContent;

_defineProperty(BreadcrumbContent, "contextType", _context["default"]);

_defineProperty(BreadcrumbContent, "className", 'MHub-Breadcrumb');

_defineProperty(BreadcrumbContent, "propTypes", {
  loading: _propTypes["default"].bool,
  loaderNode: _propTypes["default"].node
});

_defineProperty(BreadcrumbContent, "defaultProps", {
  loading: false,
  loaderNode: _react["default"].createElement(_Button["default"], {
    basic: true,
    upperCase: true,
    color: "blue"
  }, "Loading...")
});